<div class="c-user-menu__item c-user-menu__item--language">
  <mat-label
    class="c-user-menu__label"
    for="language">
    {{ "usersettings.language" | translate }}
  </mat-label>
  <mat-select
    #languageSelect
    name="language"
    id="language"
    class="c-user-menu__select c-select c-select--lg"
    (ngModelChange)="onChange(languageSelect.value?.code)"
    [(ngModel)]="currentLanguage">
    <mat-option
      *ngFor="let l of languages"
      [value]="l">
      {{ l.name }}
    </mat-option>
  </mat-select>
</div>
